import { useRef } from 'react';
import { useAppSelector } from '@store';
import { SchemaFilterType, Table } from '@ui/src';
import useList from './hooks/use-list';
import { columnsItems, columnsLabels } from './variables/list';

import cn from '../styles.module.css';

const DictionariesList = () => {
  const scrollRef = useRef<HTMLDivElement | null>(null);
  const { activePermissions } = useAppSelector((state) => state.root);
  const { dictionaries, pagination } = useAppSelector(
    (state) => state.dictionaries,
  );

  const { isLoading, setPage, errorList, filters, isFetching, takeCount } =
    useList({
      scrollRef,
      activePermissions,
    });

  return (
    <div className={cn.dictionariesBottom} ref={scrollRef}>
      <div className={cn.dictionariesTitle}>Dictionaries</div>

      <div className={cn.dictionariesTableWrapper}>
        <Table
          columns={columnsItems}
          data={dictionaries || []}
          onSort={() => {}}
          sort={{}}
          filters={filters}
          columnsLabels={columnsLabels}
          onFilterChange={() => {}}
          error={errorList}
          isLoading={isLoading || isFetching || takeCount === 0}
          storeKey="dictionaries"
          pagination={pagination}
          tableBodyClassName={isLoading || isFetching ? cn.tableLoading : ''}
          tableFormClassName={cn.externalAccountsTable}
          take={takeCount.toString()}
          setPage={(data) => {
            setPage({
              ...data,
              filters: {
                ...filters,
                take: {
                  value: [takeCount.toString()],
                  type: SchemaFilterType.STRING,
                },
              },
            });
          }}
          clickable
        />
      </div>
    </div>
  );
};

export default DictionariesList;
